import 'components/common/confirmation-dialog/index.css'
import { Theme } from '@radix-ui/themes'
import * as React from 'react'
import Modal from 'react-modal'
import DialogFooter from 'components/modals/dialog-footer'
import Button from 'components/ui/button'
import Checkbox from 'components/ui/checkbox'
import modalStyles from 'components/utils/modalStyles'
type Props = {
  caption?: React.ReactNode
  onConfirm?: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
  onHideWarningChange?: () => unknown
  hideWarning?: boolean
  confirmButtonCaption: string
  children: React.ReactNode
  hideActions?: boolean
}

const WarningDialog = ({
  caption,
  confirmButtonCaption,
  onConfirm,
  onCancel,
  hideWarning,
  onHideWarningChange,
  children,
  hideActions = false,
}: Props): React.ReactNode => {
  return (
    <Modal style={modalStyles} isOpen onRequestClose={onCancel}>
      <Theme>
        <div className="Dialog">
          {caption && <div className="Dialog_Caption">{caption}</div>}
          <div>{children}</div>
          {!hideActions && (
            <DialogFooter
              onClose={onCancel}
              corner={
                onHideWarningChange && (
                  <Checkbox
                    checked={hideWarning}
                    label="Don’t show this warning again"
                    onChange={onHideWarningChange}
                  />
                )
              }
              primary={
                <Button
                  appearance="danger"
                  caption={confirmButtonCaption}
                  onClick={onConfirm}
                />
              }
            />
          )}
        </div>
      </Theme>
    </Modal>
  )
}

export default WarningDialog
